namespace RioERP.Carts {
    export interface CartProductBillingItemsTaxRow {
        Id?: number;
        CartId?: number;
        CartProductsId?: number;
        TaxTypeId?: number;
        Rate?: number;
        TaxAmount?: number;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        CartProductBillingItemsId?: number;
        CartName?: string;
        CartFranchiseeId?: number;
        CartCustomerId?: number;
        CartCustomerName?: string;
        CartCustomerEmail1?: string;
        CartCustomerEmail2?: string;
        CartCustomerMobile1?: string;
        CartCustomerMobile2?: string;
        CartShippingAddress1?: string;
        CartShippingAddress2?: string;
        CartShippingCity?: string;
        CartShippingStateId?: number;
        CartShippingPincode?: number;
        CartEInvoiceTo?: number;
        CartInvoiceCompanyId?: number;
        CartDiscountCoupon?: string;
        CartDiscountAmount?: number;
        CartGrossAmount?: number;
        CartNetAmount?: number;
        CartTaxableAmount?: number;
        CartEFranchiseeDiscountType?: number;
        CartEFranchiseeDiscount?: number;
        CartFranchiseeDiscountValue?: number;
        CartFranchiseeDiscountAmount?: number;
        CartInsertUserId?: number;
        CartInsertDate?: string;
        CartUpdateUserId?: number;
        CartUpdateDate?: string;
        CartIsActive?: boolean;
        CartProductsCartId?: number;
        CartProductsProductId?: number;
        CartProductsQuantity?: number;
        CartProductsCost?: number;
        CartProductsGrossAmount?: number;
        CartProductsDiscountAmt?: number;
        CartProductsNetAmount?: number;
        CartProductsTaxableAmount?: number;
        CartProductsSerialKey?: string;
        CartProductsHasPendrive?: boolean;
        CartProductsHasBooks?: boolean;
        CartProductsHasCourier?: boolean;
        CartProductsDownloadUrl1?: string;
        CartProductsDownloadUrl2?: string;
        CartProductsIsActive?: boolean;
        CartProductsInvoiceCompanyId?: number;
        CartProductsFranchiseeDiscountAmount?: number;
        CartProductsFranchiseeDiscountValue?: number;
        CartProductsEFranchiseeDiscountType?: number;
        CartProductsEOpens?: number;
        CartProductsEWatchTime?: number;
        CartProductsEValidity?: number;
        CartProductsEValidityType?: number;
        CartProductsValidTill?: string;
        CartProductsTotalAllowedDuration?: number;
        CartProductsAllowedDevices?: string;
        CartProductsIsLive?: boolean;
        CartProductsEAccessStatus?: number;
        CartProductsIsTemplateSerialKey?: boolean;
        CartProductsInsertUserId?: number;
        CartProductsInsertDate?: string;
        CartProductsUpdateUserId?: number;
        CartProductsUpdateDate?: string;
        CartProductsNote?: string;
        CartProductsESerialkeyStatus?: number;
        TaxTypeName?: string;
        CartProductBillingItemsCartId?: number;
        CartProductBillingItemsCartProductsId?: number;
        CartProductBillingItemsGrossAmount?: number;
        CartProductBillingItemsDiscountAmount?: number;
        CartProductBillingItemsNetAmount?: number;
        CartProductBillingItemsTaxCategoryId?: number;
        CartProductBillingItemsProductBillingItemId?: number;
        CartProductBillingItemsInvoiceCompanyId?: number;
        CartProductBillingItemsIsActive?: boolean;
        CartProductBillingItemsInsertUserId?: number;
        CartProductBillingItemsInsertDate?: string;
        CartProductBillingItemsUpdateUserId?: number;
        CartProductBillingItemsUpdateDate?: string;
    }

    export namespace CartProductBillingItemsTaxRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Carts.CartProductBillingItemsTax';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CartId = "CartId",
            CartProductsId = "CartProductsId",
            TaxTypeId = "TaxTypeId",
            Rate = "Rate",
            TaxAmount = "TaxAmount",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            CartProductBillingItemsId = "CartProductBillingItemsId",
            CartName = "CartName",
            CartFranchiseeId = "CartFranchiseeId",
            CartCustomerId = "CartCustomerId",
            CartCustomerName = "CartCustomerName",
            CartCustomerEmail1 = "CartCustomerEmail1",
            CartCustomerEmail2 = "CartCustomerEmail2",
            CartCustomerMobile1 = "CartCustomerMobile1",
            CartCustomerMobile2 = "CartCustomerMobile2",
            CartShippingAddress1 = "CartShippingAddress1",
            CartShippingAddress2 = "CartShippingAddress2",
            CartShippingCity = "CartShippingCity",
            CartShippingStateId = "CartShippingStateId",
            CartShippingPincode = "CartShippingPincode",
            CartEInvoiceTo = "CartEInvoiceTo",
            CartInvoiceCompanyId = "CartInvoiceCompanyId",
            CartDiscountCoupon = "CartDiscountCoupon",
            CartDiscountAmount = "CartDiscountAmount",
            CartGrossAmount = "CartGrossAmount",
            CartNetAmount = "CartNetAmount",
            CartTaxableAmount = "CartTaxableAmount",
            CartEFranchiseeDiscountType = "CartEFranchiseeDiscountType",
            CartEFranchiseeDiscount = "CartEFranchiseeDiscount",
            CartFranchiseeDiscountValue = "CartFranchiseeDiscountValue",
            CartFranchiseeDiscountAmount = "CartFranchiseeDiscountAmount",
            CartInsertUserId = "CartInsertUserId",
            CartInsertDate = "CartInsertDate",
            CartUpdateUserId = "CartUpdateUserId",
            CartUpdateDate = "CartUpdateDate",
            CartIsActive = "CartIsActive",
            CartProductsCartId = "CartProductsCartId",
            CartProductsProductId = "CartProductsProductId",
            CartProductsQuantity = "CartProductsQuantity",
            CartProductsCost = "CartProductsCost",
            CartProductsGrossAmount = "CartProductsGrossAmount",
            CartProductsDiscountAmt = "CartProductsDiscountAmt",
            CartProductsNetAmount = "CartProductsNetAmount",
            CartProductsTaxableAmount = "CartProductsTaxableAmount",
            CartProductsSerialKey = "CartProductsSerialKey",
            CartProductsHasPendrive = "CartProductsHasPendrive",
            CartProductsHasBooks = "CartProductsHasBooks",
            CartProductsHasCourier = "CartProductsHasCourier",
            CartProductsDownloadUrl1 = "CartProductsDownloadUrl1",
            CartProductsDownloadUrl2 = "CartProductsDownloadUrl2",
            CartProductsIsActive = "CartProductsIsActive",
            CartProductsInvoiceCompanyId = "CartProductsInvoiceCompanyId",
            CartProductsFranchiseeDiscountAmount = "CartProductsFranchiseeDiscountAmount",
            CartProductsFranchiseeDiscountValue = "CartProductsFranchiseeDiscountValue",
            CartProductsEFranchiseeDiscountType = "CartProductsEFranchiseeDiscountType",
            CartProductsEOpens = "CartProductsEOpens",
            CartProductsEWatchTime = "CartProductsEWatchTime",
            CartProductsEValidity = "CartProductsEValidity",
            CartProductsEValidityType = "CartProductsEValidityType",
            CartProductsValidTill = "CartProductsValidTill",
            CartProductsTotalAllowedDuration = "CartProductsTotalAllowedDuration",
            CartProductsAllowedDevices = "CartProductsAllowedDevices",
            CartProductsIsLive = "CartProductsIsLive",
            CartProductsEAccessStatus = "CartProductsEAccessStatus",
            CartProductsIsTemplateSerialKey = "CartProductsIsTemplateSerialKey",
            CartProductsInsertUserId = "CartProductsInsertUserId",
            CartProductsInsertDate = "CartProductsInsertDate",
            CartProductsUpdateUserId = "CartProductsUpdateUserId",
            CartProductsUpdateDate = "CartProductsUpdateDate",
            CartProductsNote = "CartProductsNote",
            CartProductsESerialkeyStatus = "CartProductsESerialkeyStatus",
            TaxTypeName = "TaxTypeName",
            CartProductBillingItemsCartId = "CartProductBillingItemsCartId",
            CartProductBillingItemsCartProductsId = "CartProductBillingItemsCartProductsId",
            CartProductBillingItemsGrossAmount = "CartProductBillingItemsGrossAmount",
            CartProductBillingItemsDiscountAmount = "CartProductBillingItemsDiscountAmount",
            CartProductBillingItemsNetAmount = "CartProductBillingItemsNetAmount",
            CartProductBillingItemsTaxCategoryId = "CartProductBillingItemsTaxCategoryId",
            CartProductBillingItemsProductBillingItemId = "CartProductBillingItemsProductBillingItemId",
            CartProductBillingItemsInvoiceCompanyId = "CartProductBillingItemsInvoiceCompanyId",
            CartProductBillingItemsIsActive = "CartProductBillingItemsIsActive",
            CartProductBillingItemsInsertUserId = "CartProductBillingItemsInsertUserId",
            CartProductBillingItemsInsertDate = "CartProductBillingItemsInsertDate",
            CartProductBillingItemsUpdateUserId = "CartProductBillingItemsUpdateUserId",
            CartProductBillingItemsUpdateDate = "CartProductBillingItemsUpdateDate"
        }
    }
}
